import moment from "moment"

export const formatDate = (date) => {
  return moment(date).format('DD-MM-YYYY hh:mm A')
}

export const generateYearsList = (startYear = 2022) => {
  const currentYear = new Date().getFullYear();
  const yearsList = [];

  for (let year = currentYear; year >= startYear; year--) {
    yearsList.push({
      value: year,
      label: year.toString(),
    });
  }
  return yearsList;
}

export const formatString = (input) => {
  if (input) {
    return input
      .replace(/_/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
  }
}

export function setFavicon(url) {
  const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
  link.rel = 'icon';
  link.href = url;
  document.getElementsByTagName('head')[0].appendChild(link);
}

export const getImageBase64FromUrl = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // Base64 string
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const statusColors = [
  {
    status: "PENDING",
    color: "#FFA500", // Orange for pending
  },
  {
    status: "APPROVED",
    color: "#4CAF50", // Green for approved
  },
  {
    status: "REJECTED",
    color: "#F44336",   //Red
  },
  {
    status: "EXPIRED",
    color: "#F44336", //Red
  },
  {
    status: "ACTIVE",
    color: "#4CAF50", // Green for approved
  },
  {
    status: "COMPLETED",
    color: "#4CAF50", // Green for approved
  },
  {
    status: "INITIATED",
    color: "#FFA500", // Orange for pending
  },
  {
    status: "DISPATCHED",
    color: "#6f42c1", // Orange for pending
  },
  {
    status: "CANCELLED",
    color: "#ff6900", // Orange for pending
  },
];


export const StatusLabel = ({ status }) => {
  // Find the color for the given status
  const statusColor = statusColors.find(item => item.status === status)?.color || "#000"; // Default to black if status not found

  return (
    <span className="flex justify-center items-center"
      style={{
        backgroundColor: statusColor,
        color: "#fff", // White text for better contrast
        padding: "5px 10px",
        borderRadius: "5px",
        fontSize: "12px",
        fontWeight: "bold",
      }}
    >
      {status}
    </span>
  );
};

// export const handleThermalPrint = (invoiceData, accountData) => {
//   const totalGST = (
//     parseFloat(invoiceData?.totalCgst || 0) +
//     parseFloat(invoiceData?.totalSgst || 0) +
//     parseFloat(invoiceData?.totalIgst || 0)
//   ).toFixed(2);

//   const invoiceDate = new Date(invoiceData?.createdAt).toLocaleString();

//   const itemsHTML = invoiceData?.invoicedProducts?.map((product) => {
//     const total = (product.quantity * parseFloat(product.totalUnitPrice)).toFixed(2);
//     return `
//         <div class="item-row">
//           <div class="item-name">${product.product.name}</div>
//           <div class="item-qty">${product.quantity}</div>
//           <div class="item-price">₹${product.totalUnitPrice}</div>
//           <div class="item-total">₹${total}</div>
//         </div>
//       `;
//   }).join("");

//   const htmlContent = `
//       <html>
//         <head>
//           <style>
//             @media print {
//               body {
//                 font-family: monospace;
//                 font-size: 12px;
//                 width: 80mm;
//                 margin: 0;
//                 padding: 0;
//               }
//               .receipt {
//                 width: 80mm;
//                 padding: 4px;
//                 text-align: center;
//               }
//               .title {
//                 font-size: 16px;
//                 font-weight: bold;
//               }
//               .line {
//                 border-top: 1px dashed #000;
//                 margin: 4px 0;
//               }
//               .item-row {
//                 display: flex;
//                 justify-content: space-between;
//                 text-align: left;
//                 font-size: 12px;
//               }
//               .item-name {
//                 flex: 2;
//                 text-align: left;
//               }
//               .item-qty,
//               .item-price,
//               .item-total {
//                 flex: 1;
//                 text-align: right;
//               }
//               .totals {
//                 display: flex;
//                 justify-content: space-between;
//                 font-weight: bold;
//                 margin-top: 4px;
//               }
//               p {
//                 margin: 2px 0;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="receipt">
//             <div class="title">${accountData?.name?.toUpperCase() || "Company Name"}</div>
//             <p>${accountData?.address || "N/A"}, ${accountData?.city || ""}, ${accountData?.state || ""}, ${accountData?.pincode || ""}</p>
//             <p>Email: ${accountData?.email || "N/A"} | Phone: ${accountData?.mobile || "N/A"}</p>
//             ${invoiceData?.gstNumber ? `<p>GSTIN: ${invoiceData.gstNumber}</p>` : ""}
//             ${accountData?.fssaiNumber ? `<p>FSSAI: ${accountData.fssaiNumber}</p>` : ""}
//             <div class="line"></div>

//             <p><b>Invoice No:</b> ${invoiceData?.code || "N/A"} <br/><b>Date:</b> ${invoiceDate}</p>
//             <p><b>Customer:</b> ${invoiceData?.customerName || "N/A"} <br/><b>Phone:</b> ${invoiceData?.customerPhone || "N/A"}</p>
//             <div class="line"></div>

//             <div class="item-row" style="font-weight:bold;">
//               <div class="item-name">Item</div>
//               <div class="item-qty">Qty</div>
//               <div class="item-price">Rate</div>
//               <div class="item-total">Total</div>
//             </div>
//             <div class="line"></div>
//             ${itemsHTML}
//             <div class="line"></div>

//             <div class="totals"><span>Subtotal:</span><span>₹${invoiceData?.subTotal}</span></div>
//             <div class="totals"><span>GST:</span><span>₹${totalGST}</span></div>
//             <div class="totals"><span>Grand Total:</span><span>₹${invoiceData?.grandTotal}</span></div>
//             <div class="line"></div>

//             <p>Thank you for your purchase!</p>
//           </div>
//           <script>
//             window.onload = () => {
//               window.print();
//             };
//           </script>
//         </body>
//       </html>
//     `;

//   // Convert HTML to a Blob
//   const blob = new Blob([htmlContent], { type: "text/html" });
//   const blobURL = URL.createObjectURL(blob);

//   // Create an invisible iframe to load the receipt
//   const iframe = document.createElement("iframe");
//   iframe.style.display = "none";
//   iframe.src = blobURL;
//   document.body.appendChild(iframe);

//   // Cleanup when print dialog is closed
//   const cleanup = () => {
//     document.body.removeChild(iframe);
//     URL.revokeObjectURL(blobURL);
//     window.removeEventListener("focus", cleanup);
//   };
//   window.addEventListener("focus", cleanup);
// };

export const handleThermalPrint = (invoiceData, accountData) => {
  const totalGST = (
    parseFloat(invoiceData?.totalCgst || 0) +
    parseFloat(invoiceData?.totalSgst || 0) +
    parseFloat(invoiceData?.totalIgst || 0)
  ).toFixed(2);

  const invoiceDate = new Date(invoiceData?.createdAt).toLocaleString();

  const itemsHTML = invoiceData?.invoicedProducts?.map((product) => {
    const total = (product.quantity * parseFloat(product.totalUnitPrice)).toFixed(2);
    return `
      <div class="item-row">
        <div class="item-name">${product.product.name}</div>
        <div class="item-qty">${product.quantity}</div>
        <div class="item-price">₹${product.totalUnitPrice}</div>
        <div class="item-total">₹${total}</div>
      </div>
    `;
  }).join("");

  const htmlContent = `
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>
          @media print {
            * {
              box-sizing: border-box;
            }
            body {
              font-family: monospace;
              font-size: 11px;
              margin: 0;
              padding: 0;
            }
            .receipt {
              width: 100%;
              max-width: 110mm;
              min-width: 58mm;
              margin: 0 auto;
              text-align: center;
            }
            .title {
              font-size: 14px;
              font-weight: bold;
            }
            .line {
              border-top: 1px dashed #000;
              margin: 4px 0;
            }
            .item-row {
              display: flex;
              justify-content: space-between;
              font-size: 11px;
            }
            .item-name {
              flex: 3;
              text-align: left;
              word-break: break-word;
            }
            .item-qty {
              flex: 1;
              text-align: center;
            }
            .item-price, .item-total {
              flex: 1.5;
              text-align: right;
            }
            .totals {
              display: flex;
              justify-content: space-between;
              font-weight: bold;
              font-size: 12px;
              margin-top: 4px;
            }
            p {
              margin: 2px 0;
            }
          }
        </style>
      </head>
      <body>
        <div class="receipt">
          <div class="title">${accountData?.name?.toUpperCase() || "Company Name"}</div>
          <p>${accountData?.address || "N/A"}, ${accountData?.city || ""}, ${accountData?.state || ""}, ${accountData?.pincode || ""}</p>
          <p>Email: ${accountData?.email || "N/A"} | Phone: ${accountData?.mobile || "N/A"}</p>
          ${invoiceData?.gstNumber ? `<p>GSTIN: ${invoiceData.gstNumber}</p>` : ""}
          ${accountData?.fssaiNumber ? `<p>FSSAI: ${accountData.fssaiNumber}</p>` : ""}
          <div class="line"></div>

          <p><b>Invoice No:</b> ${invoiceData?.code || "N/A"}</p>
          <p><b>Date:</b> ${invoiceDate}</p>
          <p><b>Customer:</b> ${invoiceData?.customerName || "N/A"}</p>
          <p><b>Phone:</b> ${invoiceData?.customerPhone || "N/A"}</p>
          <div class="line"></div>

          <div class="item-row" style="font-weight:bold;">
            <div class="item-name">Item</div>
            <div class="item-qty">Qty</div>
            <div class="item-price">Rate</div>
            <div class="item-total">Total</div>
          </div>
          <div class="line"></div>
          ${itemsHTML}
          <div class="line"></div>

          <div class="totals"><span>Subtotal:</span><span>₹${invoiceData?.subTotal}</span></div>
          <div class="totals"><span>GST:</span><span>₹${totalGST}</span></div>
          <div class="totals"><span>Grand Total:</span><span>₹${invoiceData?.grandTotal}</span></div>
          <div class="line"></div>

          <p>Thank you for your purchase!</p>
        </div>
        <script>
          window.onload = () => {
            window.print();
          };
        </script>
      </body>
    </html>
  `;

  const blob = new Blob([htmlContent], { type: "text/html" });
  const blobURL = URL.createObjectURL(blob);

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobURL;
  document.body.appendChild(iframe);

  const cleanup = () => {
    document.body.removeChild(iframe);
    URL.revokeObjectURL(blobURL);
    window.removeEventListener("focus", cleanup);
  };
  window.addEventListener("focus", cleanup);
};